import { NgModule } from '@angular/core';

import { ApolloModule, Apollo } from 'apollo-angular';
import { setContext } from 'apollo-link-context';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { createPersistedQueryLink } from 'apollo-link-persisted-queries';
import { onError } from 'apollo-link-error';

import { environment } from './../../../environments/environment';
import { ErrorHandlingService } from '../services/error-handling.service';
import { PersistorService } from './persistor.service';
import { from } from 'apollo-link';
import { JwtService } from '../services';

@NgModule({
    imports: [ApolloModule, HttpLinkModule],
    providers: [HttpLink],
})
export class GraphQlModule {
    constructor(
        private apollo: Apollo,
        private httpLink: HttpLink,
        private errorHandlingService: ErrorHandlingService,
        private persistorService: PersistorService,
        private jwtService: JwtService,
    ) {
        const networkLink = createPersistedQueryLink().concat(
            this.httpLink.create({
                uri: `${environment.API_URL}/graphql`,
            }),
        );

        const authLink = setContext(() => {
            const token = this.jwtService.getToken();
            if (!token) {
                return {};
            } else {
                return {
                    headers: { Authorization: `Token ${token}` },
                };
            }
        });

        const errorLink = onError(({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                this.errorHandlingService.errors.next(graphQLErrors);
            }

            if (networkError) {
                this.errorHandlingService.errors.next(networkError);
                // this.jwtService.destroyToken();
            }
        });

        this.apollo.create({
            link: from([authLink, errorLink, networkLink]),
            cache: this.persistorService.cache,
            defaultOptions: {
                watchQuery: { fetchPolicy: 'cache-first', errorPolicy: 'all' },
                query: { fetchPolicy: 'network-only', errorPolicy: 'all' },
                mutate: { errorPolicy: 'all' },
            },
        });
    }
}
